module.exports = __webpack_public_path__ + "img/Image -1.2aacb49f.svg";